import { useEffect } from 'react';
import { useConversationConnectionSocketForMonitoring } from 'hooks/useConversationConnectionSocketForMonitoring';
import { useConectionSocketAdmConversation } from '../../hooks/useSocketAdmConversations';
import { removeUnAnsweredConversation } from 'store/action/unanswered-convertations-action';
import { removeConversationInAttendance } from 'store/action/conversation-in-attendance-action';
import { PlayNewAlert } from './components/Alerts';
import { useSelector } from 'react-redux';
import store from 'store';
import ConfigurationService from '../../views/SystemParams/services';
import { useSocketConversationChatTs } from 'hooks/useSocketConversationChatTs';
import { EVENTS_EMIT } from 'hooks/useSocketConversationChatTs';
import ToastFlex from 'utils/classes/ToastFlex';

const Notification = () => {
  const { socketAdm } = useConectionSocketAdmConversation();
  const { socketConversation } = useConversationConnectionSocketForMonitoring();
  const { socketChatTS } = useSocketConversationChatTs();
  const conversationInAttendance = useSelector(
    (state) => state.conversationInAttendance
  );

  const getToastPermission = () => {
    const result = localStorage.getItem('@flexuc/isNotificationsChatEnabled');
    return result === 'true';
  };

  const TOAST_TYPES = {
    ERROR: (message, action) => {
      ToastFlex.error(message, getToastPermission(), action);
    },
    SUCCESS: (message, action) => {
      ToastFlex.success(message, getToastPermission(), action);
    },
    INFO: (message, action) => {
      ToastFlex.info(message, getToastPermission(), action);
    },

    WARNING: (message, action) => {
      ToastFlex.warning(message, getToastPermission(), action);
    }
  };

  useEffect(() => {
    if (!window.Notification) {
      return;
    }
    window.Notification.requestPermission().then((permission) => {
      return permission;
    });
    // "denied" (o usuário se recusa a ter notificações exibidas),
    // "granted" (o usuário aceita ter notificações exibidas) ou
    // "default" (a escolha do usuário é desconhecido e, portanto, o navegador irá agir como se o valor foram negados).
  }, []);

  useEffect(() => {
    ConfigurationService.getAllConfigs()
      .then((response) => {
        const audioNotification = response.data.audio_chat;

        socketChatTS.on(EVENTS_EMIT.SHOW_POPUP_TO_AGENT, (data) => {
          if (data?.message && data?.type) {
            let type = 'new_message';
            TOAST_TYPES[data.type](data.message, type);
          }
        });

        socketConversation.on('cliente_enviou_mensagem_portal_chat', (data) => {
          let permission = window.Notification.permission;
          let type = 'new_message';
          PlayNewAlert(data, permission, type, audioNotification);
        });
        socketChatTS.on('cliente_enviou_mensagem', (data) => {
          if (data?.isAssigned) return;
          let permission = window.Notification.permission;
          let type = 'new_message';
          PlayNewAlert(
            { ...data, action: 'NEW_MESSAGE' },
            permission,
            type,
            audioNotification
          );
        });
        socketAdm.on('entrou_na_fila', (data) => {
          const attendantQueues = JSON.parse(localStorage.getItem('queues'));
          if (attendantQueues) {
            attendantQueues.forEach(async (attendantQueue) => {
              if (
                data.conversa?.fila &&
                data.conversa.fila === attendantQueue.name
              ) {
                let permission = window.Notification.permission;
                let type = 'client_in_queue';
                PlayNewAlert(
                  data.conversa,
                  permission,
                  type,
                  audioNotification
                );
              }
            });
          }
        });
        socketConversation.on(
          'conversa_transferida_pelo_bot_para_atendente',
          (data) => {
            const attendantLogin = localStorage.getItem('login');
            const { conversa } = data;
            if (
              conversa.atendente.id_postgres === attendantLogin &&
              conversa.atendida
            ) {
              let permission = window.Notification.permission;
              let type = 'exclusiveconversation';
              PlayNewAlert(conversa, permission, type, audioNotification);
            }
          }
        );

        socketChatTS.on(
          'conversa_transferida_pelo_bot_para_atendente',
          (data) => {
            const attendantLogin = localStorage.getItem('login');
            const { conversa } = data;
            if (
              conversa.atendente.id_postgres === attendantLogin &&
              conversa.atendida
            ) {
              let permission = window.Notification.permission;
              let type = 'exclusive_conversation';
              PlayNewAlert(conversa, permission, type, audioNotification);
            }
          }
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, [socketConversation, socketAdm, socketChatTS]);

  useEffect(() => {
    socketAdm.on('conversa_abandonada_cliente', async (data) => {
      if (data.id === conversationInAttendance.conversation._id) {
        await store.dispatch(removeConversationInAttendance());
      }

      await store.dispatch(removeUnAnsweredConversation(data.id));
    });

    return () => socketAdm.off('conversa_abandonada_cliente');
  }, [socketAdm, conversationInAttendance]);

  return null;
};

export default Notification;
